import at from '../actionTypes'
import createReducer from './utilities/createReducer'

//  Generic fetch error
export default createReducer({}, {
	[at.FETCH_ERROR]: (state, action) => ({
		...state,
		error: action.payload.error
	})
})



// WEBPACK FOOTER //
// ./src/redux/reducers/fetchReducer.js